import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { history } from '../../../../store';

import LoadingIcon from '../../../common/icons/LoadingIcon';

import sectionStyles from './_styles/DashboardSection.module.scss';
import styles from './_styles/DashboardProducts.module.scss';

import * as ddnyActionCreators from '../../../../actions/ddny';
const allActionCreators = Object.assign({}, ddnyActionCreators);

export class DashboardProducts extends Component {

	constructor(props) {
		super(props);
		this.state = {
			requestPending: false,
			requestData: {},
		};
	}

	componentDidMount() {
		this.fetchProductData();
	}

	async fetchProductData() {
		this.setState({ requestPending: true });
		try {
			const productTotals = await this.props.ddnyFetchProductTotals();
			this.setState({ requestData: productTotals });
		} catch(err) {
			console.error(err);
		} finally {
			this.setState({ requestPending: false });
		}
	}

	viewAll() {
		this.props.ddnySetFilters({});
		history.push('/ddny/gallery');
	}

	render() {
		return <div className={`${styles.DashboardProducts} ${sectionStyles.DashboardSection}`}>
			<div className={sectionStyles.titleWrapper}>
				<div className={sectionStyles.title}>Products</div>
				<Link to={'/ddny/jewelry/edit/new'}>
					<div className={sectionStyles.action}>Add</div>
				</Link>
			</div>
			<div className={`${sectionStyles.body}`}>
				{this.state.requestPending
					?	<div className={sectionStyles.loading}>
							<div className={sectionStyles.iconWrapper}>
								<LoadingIcon />
							</div>
						</div>
					:	<div className={sectionStyles.loaded}>
							<div className={styles.dataRow}>
								<div className={`${styles.label} ${styles.large}`}>All products:</div>
								<div className={`${styles.value} ${styles.large}`}>{this.state.requestData.all || 0}</div>
							</div>
							<div className={styles.dataRow}>
								<div className={styles.label}>Enabled products:</div>
								<div className={styles.value}>{this.state.requestData.enabled || 0}</div>
							</div>
							<div className={styles.actionRow}>
								<button className={`${styles.action} actionButton`} onClick={this.viewAll.bind(this)}>
									View All
								</button>
							</div>
						</div>
				}
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(DashboardProducts);